<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header inline space-between top">
        <img class="mega" src="@/assets/logoMegaHeader.svg" />
        <div class="select">
          <select name="cookiesLangSelect" id="cookiesLangSelect" v-model="$i18n.locale">
            <option>fr</option>
            <option>nl</option>
          </select>
        </div>
      </div>
      <img class="cookie" src="@/assets/cookies.svg" />

      <div class="modal-body">
        <h1>{{ $t('cookies.title') }}</h1>
        <p>
          {{ $t('cookies.text') }}
        </p>
        <div class="buttons">
          <button class="main" @click="setCookies(acceptAll = true)">{{ $t('cookies.acceptAll') }}</button>
          <button class="second" @click="options = !options">{{ $t('cookies.config') }}</button>
        </div>
        <transition name="slide-fade">
          <div class="options" v-if="options">
            <div class="option">
              <h2 @click="neededPanel = !neededPanel" style="cursor:pointer;">
                <SvgIcon class="icon" icon="cookie"></SvgIcon>
                <span>{{ $t('cookies.needed.title') }}</span>
              </h2>
              <transition name="slide-fade">
                <p v-if="neededPanel">
                  {{ $t('cookies.needed.text') }}
                  <input type="checkbox" disabled v-model="needed" checked />
                </p>
              </transition>
            </div>
            <div class="option">
              <h2 @click="analyticPanel = !analyticPanel" style="cursor:pointer;">
                <SvgIcon class="icon" icon="cookie"></SvgIcon>
                <span>{{ $t('cookies.analytic.title') }}</span>
              </h2>
              <transition name="slide-fade">
                <p v-if="analyticPanel">
                  {{ $t('cookies.analytic.text') }}
                  <input type="checkbox" v-model="analytic" checked />
                </p>
              </transition>
            </div>
            <div class="option">
              <h2 @click="adPanel = !adPanel" style="cursor:pointer;">
                <SvgIcon class="icon" icon="cookie"></SvgIcon>
                <span>{{ $t('cookies.marketing.title') }}</span>
              </h2>
              <transition name="slide-fade">
                <p v-if="adPanel">
                  {{ $t('cookies.marketing.text') }}
                  <input type="checkbox" v-model="ad" checked />
                </p>
              </transition>
            </div>

            <div class="buttons box-cookies">
              <button class="main bg-white" @click="setCookies(acceptAll = false)">{{ $t('cookies.save') }}</button>
              <button class="main" @click="setCookies(acceptAll = true)">{{ $t('cookies.acceptAll') }}</button>
            </div>

            <div class="option" style="text-align: center;">
              <button class="second" style="margin-right: auto !important;" @click="refuseAllCookies()">{{ $t('cookies.refuseAll') }}</button>
            </div>

          </div>

        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      acceptAll: false,
      options: false,
      neededPanel: false,
      needed: true,
      analyticPanel: false,
      analytic: false,
      adPanel: false,
      ad: false,
    };
  },
  methods: {
    setCookies() {
      let d = new Date();
      d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
      let expireTimes = d.toGMTString();

      let domain = process.env.DOMAIN;

      let value = '';
      if(this.acceptAll === true) {
        value = "cookiesNecessary:accepted|cookiesStatistic:accepted|cookiesMarketing:accepted|"
        document.cookie = "megacookie=" + value + ";" + expireTimes + ";path=/;domain=" + domain;
        dataLayer.push( {
          'event' : 'cookiesAcceptation',
          'cookiesNecessary': 'accepted',
          'cookiesStatistic' : 'accepted',
          'cookiesMarketing': 'accepted'
        });
      }
      else {
        value = "cookiesNecessary:accepted|"
        value = this.analytic ? value + "cookiesStatistic:accepted|" : value + "cookiesStatistic:declined|";
        value = this.ad ? value + "cookiesMarketing:accepted|" : value + "cookiesMarketing:declined|";
        document.cookie = "megacookie=" + value + ";" + expireTimes + ";path=/;domain=" + domain;

        dataLayer.push( {
          'event' : 'cookiesAcceptation',
          'cookiesNecessary': 'accepted',
          'cookiesStatistic' : this.analytic ? 'accepted' : 'declined',
          'cookiesMarketing': this.ad ? 'accepted' : 'declined'
        });
      }

      document.body.classList.remove("modal-open");
      this.$emit('close');
    },
    refuseAllCookies() {
      let d = new Date();
      d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
      let expireTimes = d.toGMTString();

      let domain = process.env.DOMAIN;

      let value = 'cookiesNecessary:accepted|cookiesStatistic:declined|cookiesMarketing:declined|';
      document.cookie = "megacookie=" + value + ";" + expireTimes + ";path=/;domain=" + domain;

      dataLayer.push( {
        'event' : 'cookiesAcceptation',
        'cookiesNecessary': 'accepted',
        'cookiesStatistic' : 'declined',
        'cookiesMarketing': 'declined',
        'cookiesSocial' : 'declined'
      });

      document.body.classList.remove("modal-open");
      this.$emit('close');
    }
  },
  created() {
    document.body.classList.add("modal-open");
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  overflow: auto;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;

  .modal {
    margin: 30px auto;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    max-width: 758px;
    position: relative;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    outline: 0;
    -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    padding: 15px;

    .modal-header {
      .mega {
        max-width: 122px;
        height: 32px;
      }

      .select {
        max-width: 122px;
        text-align: right;

        select {
          padding: 5px 0;
          width: 85px;
        }
      }
    }

    .cookie {
      max-width: 162px;
      margin-top: 10px;
    }

    .box-cookies {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      width: 80%;
      margin: auto;
      height: 100px;
    }

    .bg-white {
      background-color: #FFFFFF !important;
      border: 1px solid #FDCB47 !important;
      cursor:pointer;
    }

    .modal-body {
      font-family: "ObjectSans", Arial, Helvetica, sans-serif;

      h1 {
        font-size: 1.2rem;
        font-weight: 600;
        padding: 0px;
      }

      p {
        text-align: left;
        margin: 0;
        font-size: 0.9rem !important;
        font-weight: 100;
        line-height: 1.5rem;
      }

      button {
        display: block;
        margin: 15px auto;
        border: none;

        &.main {
          border-radius: 52px !important;
          padding: 0.75em 2.2em !important;
          font-size: 1.4rem !important;
          font-weight: 600;
          color: #231f20;
          background-color: #fdcb47;
          -webkit-transition: 0.15s ease-in;
          cursor:pointer;

          &:hover {
            color: #fdcb47;
            background-color: #231f20;
          }
        }

        &.second {
          font-size: 1rem;
          background: none;
          text-decoration: underline;
          text-decoration-color: #fdcb47;

          &:hover {
            text-decoration: none;
            cursor: pointer;
          }
        }
      }

      .options {
        text-align: left;

        .option {
          h2 {
            padding: 5px;
            font-weight: 200;
            font-size: 1rem;
            background: none;

            .icon {
              display: inline;
              margin-right: 10px;
            }

            span {
              text-decoration: underline;
              text-decoration-color: #fdcb47;
            }
          }

          p {
            display: flex;
            margin: 0;
            margin-left: 35px;
          }
        }

        button {
          margin-right: 10px;
          margin-bottom: 5px;
        }
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Cookies.vue